import React from 'react'
import { Modal } from 'antd'
import { capitalizeFirstLetter } from '../utilities/helpers'
import { Observer } from 'mobx-react-lite'
import { ReceiptModels, ReceiptUtils } from '@getgreenline/receipts'

interface Props {
  packingSlipData: ReceiptModels.IPackingSlipData
  isPackingSlipOpen: boolean
  onCancel: () => void
  printPackingSlip: VoidFunction
  canUseCustomReceipt: boolean
  receiptSettings: ReceiptModels.IReceiptContract
  setIsReadyForPrint?: (isReady: boolean) => void
}

const getParkedSaleOrderTypeText = (packingSlipData: ReceiptModels.IPackingSlipData) => {
  let orderType = ''

  if (packingSlipData.payment && 'orderType' in packingSlipData.payment) {
    orderType = capitalizeFirstLetter(packingSlipData.payment.orderType)
  }

  return orderType
}

export const PackingSlip = ({
  packingSlipData,
  isPackingSlipOpen,
  onCancel,
  printPackingSlip,
  canUseCustomReceipt,
  receiptSettings,
  setIsReadyForPrint,
}: Props) => {
  const fontSize = '1rem'
  const ref = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    setIsReadyForPrint && setIsReadyForPrint(true)

    return () => {
      setIsReadyForPrint && setIsReadyForPrint(false)
    }
  }, [ref])

  return (
    <Observer>
      {() => (
        <Modal
          title={`Parked sale ${getParkedSaleOrderTypeText(packingSlipData)}`}
          centered
          visible={isPackingSlipOpen}
          onOk={printPackingSlip}
          okText='Print'
          onCancel={onCancel}
          cancelText='Close'
        >
          <div
            ref={ref}
            dangerouslySetInnerHTML={{
              __html: canUseCustomReceipt
                ? ReceiptUtils.generateCustomPackingSlipHTMLV2(
                    packingSlipData,
                    receiptSettings,
                    fontSize,
                  )
                : ReceiptUtils.generateCustomPackingSlipHTMLV1(packingSlipData, fontSize),
            }}
          />
        </Modal>
      )}
    </Observer>
  )
}
